import React from "react";
import { icons } from "../../assets/icons";

const CustomAccordion = ({ items, activeIndex, setActiveIndex }) => {
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const renderedItems = items.map((item, index) => {
    const isActive = index === activeIndex;

    return (
      <div key={index} className="flex flex-col mt-4">
        <div
          className={`flex items-center border-b-[1px] border-b-[var(--borderGray1)] ${
            isActive ? "accordion-active" : ""
          }`}
        >
          <div
            className="text-[var(--blackColor)]"
            onClick={() => setActiveIndex(index)}
          >
            {item?.renderLeft ? item.renderLeft() : null}
          </div>
          <div
            onClick={() => onItemClick(index)}
            className={`flex flex-1 justify-between h-[5rem] items-center w-100 bg-[var(--whiteColor)] px-5 cursor-pointer accordion-not-active`}
          >
            <div className="flex items-center gap-x-8 ml-auto">
              {item?.renderRight && !isActive ? item.renderRight() : null}
              <img
                className={`arrow ${isActive ? "rotate" : ""}`}
                src={icons.arrowDown}
                alt="arrow down icon"
              />
            </div>
          </div>
        </div>
        <div className={`accordion-content ${isActive ? "block" : "hidden"}`}>
          {item?.Component ? <item.Component /> : null}
        </div>
      </div>
    );
  });

  return <div className="accordion">{renderedItems}</div>;
};

export default CustomAccordion;
